import React,{useState} from "react";
import {faShareAlt, faTimesCircle} from '@fortawesome/free-solid-svg-icons';

import Modal from '../../modal/Modal';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faTwitter, faFacebook, faWhatsapp} from '@fortawesome/free-brands-svg-icons';


import './Compartilhar.css';

const Compartilhar = ({className}) => {

	const encodeLink = "https://eic.ifsc.usp.br/app/infocovid19";
	const [isOpen, setIsOpen] = useState(false);

	const handleWhatsapp = () => {
        window.open('https://api.whatsapp.com/send?text=Venha jogar e descobrir mais sobre a Covid19 no InfoCovid19. Esse e outros jogos estão disponíveis no site: http://eic.ifsc.usp.br','_system', 'location=yes'); 
        return false;
    }

    const handleTwitter = () => {
        const link = "https://twitter.com/intent/tweet?hashtags=eiciencias%20&original_referer=https%3A%2F%2Fpublish.twitter.com%2F%3FbuttonHashtag%3Deiciencias%2520%26buttonText%3DVenha%2520jogar%2520e%2520descobrir%2520mais%2520sobre%2520a%2520Covid19%2520no%2520InfoCovid19.%2520Esse%2520e%2520outros%2520jogos%2520est%25C3%25A3o%2520dispon%25C3%25ADveis%2520no%2520site%253A%26buttonType%3DTweetButton%26buttonUrl%3Dhttps%253A%252F%252Feic.ifsc.usp.br%252Fapp%252Finfocovid19%26dnt%3D1%26lang%3Dpt%26theme%3Ddark%26widget%3DButton&ref_src=twsrc%5Etfw&text=Venha%20jogar%20e%20descobrir%20mais%20sobre%20a%20Covid19%20no%20InfoCovid19.%20Esse%20e%20outros%20jogos%20estão%20disponíveis%20no%20site%3A&tw_p=tweetbutton&url=https%3A%2F%2Feic.ifsc.usp.br%2Fapp%2Finfocovid19";
        window.open(link,'_system', 'location=yes'); 
    }

    const handleFacebook = () => {
        const link = "https://www.facebook.com/sharer/sharer.php?kid_directed_site=0&sdk=joey&u=https%3A%2F%2Feic.ifsc.usp.br%2Fapp%2Finfocovid19&display=popup&ref=plugin&src=share_button";
        window.open(link,'_system', 'location=yes'); 
    }

	const CompartilharButton = <div className="contentCompartilharButton row nowrap startContent centerItens" onClick= {()=>{setIsOpen(!isOpen)}}>
                                    <div className="icon">
                                        <FontAwesomeIcon icon={faShareAlt}/>
                                    </div>
                                    <div className="name">
                                        Compartilhar
                                    </div>
                                </div>;
	return(
		<Modal button={CompartilharButton} visible={isOpen}>
			<div className="modalShare column nowrap centerItens">
				<div className="head row nowrap evenlyContent">
					<span className="colorEIC title">Compartilhar</span>
					<div className = "close colorEIC shadow column spaceBeteweenContent centerItens startItens">
						<FontAwesomeIcon className="close" icon = {faTimesCircle} onClick = {()=>{setIsOpen(!isOpen)}} />
					</div>
				</div>
				
				<div className="content column nowrap justifyText centerText colorEIC">
						<div className="button shadow backgroundEIC row nowrap centerItens" onClick = {handleFacebook}>
							<div className="icon">
								<FontAwesomeIcon icon = {faFacebook}/>
							</div>
							<div className="name">
								Facebook
							</div>
						</div>
						<div className="button shadow backgroundEIC row nowrap centerItens" onClick = {handleWhatsapp}>
							<div className="icon">
								<FontAwesomeIcon icon = {faWhatsapp}/>
							</div>
							<div className="name">
								Whatsapp
							</div>
						</div>
					<div className="button shadow backgroundEIC row nowrap centerItens" onClick = {handleTwitter} >
						<div className="icon">
							<FontAwesomeIcon icon = {faTwitter}/>
						</div>
						<div className="name">
							Twitter
						</div>
					</div>
				</div>
			</div>
		</Modal>
	);
};


export default Compartilhar;

